import { Directive, Input, ElementRef, HostListener, Renderer } from '@angular/core'

declare var $: any;

@Directive({
    selector: '[state]'
})

export class StateDirective {
    @Input('state') valid: any;
    private validateClass = '';
    constructor( private _el: ElementRef, private _renderer: Renderer) {
    }

    @HostListener('input', ['$event'])
    onInput(event) {
      this.setValideStyle();
    }

    @HostListener('focus', ['$event'])
    onFocus(event) {
      this.setValideStyle();
    }

    @HostListener('focusout', ['$event'])
    onFocusout(event) {
      $('.form-group').removeClass(this.validateClass);
    }

    setValideStyle() {
      if (this.valid) {
        this.validateClass = 'has-success';
      } else {
        this.validateClass = 'has-error';
      }
      $('.form-group').addClass(this.validateClass);
    }
}
